// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> aion-management-stadium-house -> franklin-commons-apartments
// Generated: 2026-11-03T22:47:42.426Z
// Counts: 1 design, 98 content, 66 slot group, 2 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities Built For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>YOUR NEW HOME AWAITS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>WE'RE HERE TO HELP</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE COMFORTS OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>One- and Two-Bedroom Apartments in Bensalem, PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself At Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>A STILL-SHOT OF YOUR NEW LIFE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Franklin Commons Apartments Photos</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartments for Rent in Bensalem, PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Local History and Attractions in Bensalem</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Bensalem, PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Your Ideal Lifestyle at Our Charming Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>ACCESS YOUR RESIDENT PORTAL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Login</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>your perfect apartment is here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>360° views right here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Apartment Tours in Bensalem, PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE CONVENIENCE OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Apartment Amenities in Bensalem</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "left",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Pet Policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, your lifestyle blends comfort and convenience. Choose from spacious one- or two-bedroom floor plans, all adorned with modern finishes. Enjoy a vibrant community featuring a fitness center, swimming pool, and a dog park—all designed to elevate your living experience. Join us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Franklin Commons Apartments in Bensalem, PA, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans, and enjoy amenities like a sparkling swimming pool, dog park, and vibrant resident activities. Embrace convenience with our bilingual team, online portal, and flexible rent options. Your ideal lifestyle awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, you'll find the perfect blend of comfort and convenience. Choose from spacious one and two-bedroom floor plans while enjoying amenities like a pet-friendly environment, a fitness center, and a sparkling swimming pool. Ready to make a move? Lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, find your ideal home with thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Each space offers comfort and style, ensconced in a vibrant community. Have questions? Contact our leasing team today for personalized assistance!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$75",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.community_amenity_fee": {
    "overrideType": "VALUE",
    "customValue": "$150",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.reservation_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.security_deposit": {
    "overrideType": "VALUE",
    "customValue": "$750",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_admin_billing_fee": {
    "overrideType": "VALUE",
    "customValue": "$4.53",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_electric": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_gas": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_water_sewer": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.valet_trash_fee": {
    "overrideType": "VALUE",
    "customValue": "$25",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, you’ll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Each space combines comfort and modern aesthetics, ensuring a welcoming haven. Browse our available apartment homes and uncover the perfect layout to suit your needs!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, every moment feels like home. Choose from stylish one and two-bedroom floor plans, and indulge in exceptional amenities, from our fitness center and swimming pool to a pet-friendly environment. Picture yourself relaxing by the fire pit or having fun at our game room!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments in Bensalem , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Franklin Commons Apartments puts you in the heart of Bensalem, Bucks County, with public transportation within walking distance and Philadelphia close by.</p><p>Enjoy the outdoors at Neshaminy State Park and Benjamin Rush State Park, visit the historic Growden Mansion, shop at Neshaminy Mall, and grab breakfast at Sunrise Diner. Browse the places nearby, then explore our one- and two-bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit in a great location in Bucks County with a one or two bedroom apartment at Franklin Commons. This garden-style community features amenities designed to simplify your life and a friendly vibe that will make you feel welcome from day one. Our spacious, pet-friendly floor plans have been thoughtfully upgraded for style and comfort.</p><p>You’ll love the convenience of this Bensalem location, with an array of shops, restaurants, and entertainment options at your fingertips.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Franklin Commons Apartments in Bensalem, PA, where modern living meets convenience. Choose from spacious one and two-bedroom floor plans tailored to fit your lifestyle. Access your resident portal for hassle-free rent payments, maintenance scheduling, and a host of resident services designed for your comfort and ease!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Franklin Commons Apartments in Bensalem, PA, we offer spacious one and two-bedroom floor plans designed for modern living. Schedule a tour today to experience our vibrant community and see what our residents love about calling Franklin Commons home. Join us and write your own story in Bensalem!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Franklin Commons Apartments in Bensalem, PA! Our inviting community features thoughtfully designed one and two-bedroom floor plans, tailored to your lifestyle. A member of our team will be in touch soon to help you find your perfect home. Welcome to your new beginning!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into the charm of Franklin Commons Apartments in Bensalem, PA. With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Experience the comfort and style from the comfort of your home—take a virtual tour of our vibrant community and explore your future today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_secondary_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "footer.emergency_badge": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a159e7-a80b-77ee-97d6-e8506cb14dfb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "2-1-1 New Jersey logo"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      }
    }
  },
  "propertyoverview.cta_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Swimming Pool with Sundeck"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-90f1-7339-b5ac-75071f7e9adc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool with lounge chairs and umbrellas."
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-98c5-70cb-98dc-f40c1bbb1635.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright, modern apartment gym with cardio machines and mirrors."
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Clubhouse"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-9713-771c-8135-efdd4eee02f1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with sectional sofa, chairs, and coffee table in a multifamily property."
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Dog Park"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166317/019fd956-b103-71cb-b1b9-634af7f33807.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment including ramps and tunnels. Buildings in background."
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166317/019fd956-8151-70d9-8f80-f1782ab8400c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "In-home kitchen with stainless steel appliances, dark wood cabinets, and white subway tile backsplash."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-9d96-77ee-bb13-96a8b397b21a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor resident clubhouse with a billiards table, shuffleboard, sofa seating, and a large TV."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-663e-759f-8819-73076904ba72.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright community room with angled wooden ceiling, comfortable seating, and large windows."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-018d-77a8-96fb-99bf7de39548.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright fitness center with treadmills, ellipticals, bikes, and large windows."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-788d-716b-a92b-c80df71d80e8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Communal recreation room with a pool table, shuffleboard, sofa, and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-dba4-7344-b6aa-3849b9a83392.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with stainless steel appliances and dark wood cabinets."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-6025-771f-b716-de81133ae1f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room with gray sofa, ottoman, glass coffee table, lamps, and a large window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-e73d-70d5-9686-cba0615cd12d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a gray upholstered bed, two matching nightstands, dresser, and window."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-bf25-731b-b7db-de904e5f7559.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a brick apartment building with a manicured green lawn and trees under a blue sky."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166317/019d0267-44ce-7416-9bfe-e294d5c8b79d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of brick apartment buildings with a large green lawn and trees under a blue sky with clouds."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-63c4-70bd-80d1-3d8e764b25ee.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Front view of a beige apartment community clubhouse with white columns and an arched entry under a blue sky."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166317/019d0267-4339-762b-bf67-d84a10674ece.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a brick apartment building with large trees and a grassy lawn."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-90f1-7339-b5ac-75071f7e9adc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community swimming pool with lounge chairs, umbrellas, and landscaped surroundings."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-7ba2-76ba-a464-b97aabfa4aec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool with blue water, lounge chairs, and turquoise umbrellas."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-706c-72b8-bedd-ba9c4e510ca9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Row of stainless steel built-in grills along a stone counter in a landscaped outdoor area."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166317/019d0267-0a35-7439-8f1b-af4ea069246e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with agility equipment like ramps and tunnels."
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "150"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Valet Trash"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-601d-73fb-ac24-198e4342cf7f.webp"
      }
    }
  },
  "footer.cta_background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-601d-73fb-ac24-198e4342cf7f.webp"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-601d-73fb-ac24-198e4342cf7f.webp"
      }
    }
  },
  "hero.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "COOL Amenities"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Discover how our community makes life convenient and fun."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "LUXURY HOMES"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Spaces designed for comfort, focus, and everyday living."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "APPLY"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Fill out the contact form and be one step closer to applying."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8d2e-714e-b28e-12172358462d.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Panera Bread"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Cafe & Bakery"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.9"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Counter-serve bakery-cafe serving sandwiches, salads and soups, known for its fresh-baked bread and free WiFi."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-bf40-722d-97a8-2dc449074c00.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Neshaminy Mall"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Shopping & Retail"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3.4"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shopping center packed with apparel, home and shoe stores, plus dining options and a movie theater."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-de5c-70eb-a107-a7bda8331dc8.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Neshaminy State Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "4.1"
      },
      "description": {
        "type": "VALUE",
        "customValue": "334-acre riverfront park with fishing, walking paths, seasonal pools and picnic pavilions."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8dd2-70fd-a927-d2b634b01e12.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Sunrise Diner"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.8"
      },
      "description": {
        "type": "VALUE",
        "customValue": "American home cooking for breakfast, lunch and dinner in a relaxed setting with comfortable booths."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-e50f-7529-ae13-e96ef9776f59.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Growden Mansion"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Arts & Culture"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.2"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Restored 18th-century Bensalem landmark and historic estate, a picturesque stop for a stroll through local heritage and grounds."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0de6-71f8-a9a2-8c9919203655.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Benjamin Rush State Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Recreation & Trails"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "State park with hiking and biking paths, a community garden and a radio-control model airplane field for open-air recreation."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-94b9-70c6-be23-8158f6b1306d.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Chickie's & Pete's"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Sports Bar"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.2"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Local sports-bar favorite with a crab-heavy menu, signature Crabfries and TVs on every wall."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d3b2-740e-836c-af5c4b7915c1.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Penn Community Bank Amphitheater"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Live Music & Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Open-air amphitheater hosting concerts and live entertainment throughout the warmer months."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-aa65-71c9-95c9-e0ced40b3811.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Fisher's Catering Restaurant"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Fine Dining"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Warm sit-down eatery serving gnocchi, lobster ravioli and other classic Italian dishes."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d2fb-76fe-a410-bb584618c482.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Parx Casino"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Nightlife & Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Late-night 'racino' with live horse racing, slots, table games and poker, plus a lineup of restaurants and bars."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d637-73ae-8b5c-d66eac27b167.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "AMC Neshaminy 24"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Cinema & Theater"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3.4"
      },
      "description": {
        "type": "VALUE",
        "customValue": "24-screen multiplex with IMAX and Dolby sound, spacious reclining seats and the latest releases for a night at the movies."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-b700-75e8-8797-68c0a8a64a1e.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Wawa"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Late-Night Eats"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.6"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Beloved local convenience stop open 24/7 for made-to-order hoagies, coffee and snacks whenever the after-hours craving hits."
      }
    }
  },
  "propertyoverview.image_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-6025-771f-b716-de81133ae1f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room with gray sofa, ottoman, glass coffee table, lamps, and a large window."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_46702e60-016e-42d3-b0a2-b2ba7c58505d",
      "custom_c2701df9-4b10-40f7-bf53-bdba2b7714c4",
      "custom_86c5132e-873b-437a-a9ff-f21a51e25ac4",
      "custom_c7f12306-24d5-4448-bdc8-769e2f32f4d7",
      "custom_b1baf9e6-63f3-4a71-803a-8fa2480fe82a",
      "custom_e4c4502e-3a04-4e1b-ad47-0550a6efc49c",
      "custom_38787e26-8505-4b36-9e79-56a1bb902440",
      "custom_b006b0d8-6988-4854-8724-9fd0b4cb5af5",
      "custom_8ae8d7b9-93ed-4395-90eb-5f38a0fcc15c",
      "custom_f727153e-7ece-43d7-8892-0b9442701463",
      "custom_710f2de5-db9b-4a15-96cb-639eb7951b73",
      "custom_64ab1a8b-1ffd-4eae-810c-96b617dcd782",
      "custom_8ff5bc24-4479-47a0-b99f-c02c0b443131",
      "custom_ac833be7-083b-49e2-8519-71aacdf77e31",
      "custom_5cfa8bd2-be9d-4330-9376-302ba89db35c",
      "custom_18cc29da-c674-4d8e-abcf-83d789268c68",
      "custom_449db389-22d6-4e5b-9a64-e66a3fef6891",
      "custom_9b2dc482-a565-407f-b983-0c9323f03d0c",
      "custom_f45e5e28-01c1-479b-94ce-5e2f47e2ca82",
      "custom_7cbf4cef-18ac-432d-ad5f-58684f740ec7",
      "custom_82108fea-c72e-440b-b317-075b62dcbc05",
      "custom_a09a138e-8171-400a-8185-f1fa79115212",
      "custom_6797562a-0c21-4ec7-be13-444cb126a71e",
      "custom_7d55351b-9d7c-40e4-a3f8-01b788075d12",
      "custom_0cc62c0a-f82f-4b8b-bf28-ea4f5eae1a02",
      "custom_36fd9cdf-be71-46ec-b574-b4e5a3db5869",
      "custom_505893e0-4698-4dac-8a9b-75f8da8ed43b",
      "custom_7a292a24-4175-4123-bc4c-250326cd41a2",
      "custom_cf024d1b-d6fb-4193-ba07-95b2b7479373",
      "custom_e2840ead-a4c5-4e79-922f-67b63b74e81f",
      "custom_c8fead37-331e-4cc6-9123-06e3077bbf67",
      "custom_295ea82e-37df-456c-a4e0-e7001c7869a4",
      "custom_7b8ea5c8-43c5-4271-8157-ecb3002bd711",
      "custom_68df285b-70d2-4690-a1a2-c3dafc65f6db",
      "custom_0bcbac0f-77f4-4968-b0eb-841051269d34",
      "custom_0de7f5df-f1b1-4caa-bce6-ab4bcd7d2d9c"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": [
      "custom_38787e26-8505-4b36-9e79-56a1bb902440",
      "custom_b1baf9e6-63f3-4a71-803a-8fa2480fe82a",
      "custom_b006b0d8-6988-4854-8724-9fd0b4cb5af5",
      "custom_46702e60-016e-42d3-b0a2-b2ba7c58505d",
      "custom_8ae8d7b9-93ed-4395-90eb-5f38a0fcc15c",
      "custom_8ff5bc24-4479-47a0-b99f-c02c0b443131",
      "custom_ac833be7-083b-49e2-8519-71aacdf77e31",
      "custom_5cfa8bd2-be9d-4330-9376-302ba89db35c",
      "custom_86c5132e-873b-437a-a9ff-f21a51e25ac4",
      "custom_c7f12306-24d5-4448-bdc8-769e2f32f4d7",
      "custom_c2701df9-4b10-40f7-bf53-bdba2b7714c4",
      "custom_e4c4502e-3a04-4e1b-ad47-0550a6efc49c",
      "custom_64ab1a8b-1ffd-4eae-810c-96b617dcd782",
      "custom_710f2de5-db9b-4a15-96cb-639eb7951b73",
      "custom_f727153e-7ece-43d7-8892-0b9442701463"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.PetPolicyCallout": {
    "properties": {
      "paddingTop": "0px"
    }
  },
  "header.address_link": {
    "properties": {
      "paddingTop": "5px"
    }
  }
};
